
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ecoflow-power-kits/series",
      function () {
        return require("private-next-pages/ecoflow-power-kits/series/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ecoflow-power-kits/series"])
      });
    }
  